import React, { useState } from 'react';
import { apiFetch } from '../utils/api'; // Make sure path is correct
import '../App.css';

const RequestPasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrorMessage('');
    setIsLoading(true);

    try {
      const response = await apiFetch('/api/users/request-password-reset', 'POST', { email });

      if (response.success) {
        setMessage(response.message || 'Please check your email for the reset link.');
      } else {
        setErrorMessage(response.message || 'Failed to send reset link.');
      }
    } catch (error) {
      console.error('Reset error:', error);
      setErrorMessage(error.message || 'An error occurred while requesting reset.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container page-container mt-5" style={{ maxWidth: '500px' }}>
      <h2 className="text-primary text-center mb-4">Request Password Reset</h2>

      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      {message && <div className="alert alert-success">{message}</div>}

      <form onSubmit={handleSubmit} className="mt-3">
        <div className="form-group mb-3">
          <input
            type="email"
            className="form-control"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
          {isLoading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
    </div>
  );
};

export default RequestPasswordReset;

